import { Box, Stack, Typography } from "@mui/material"
import type { FormaPagamentoLoja } from "@/api"
import PaymentMethodCard from "./payment-method-card"
import type { MetodoPagamento } from "./payment-methods"
import { metodosDoCheckout } from "./passos-pagamento"

interface EscolhaMetodoProps {
    forma: FormaPagamentoLoja
    valorFormatado: string
    onEscolher: (metodo: MetodoPagamento) => void
}

/** Forma que aceita mais de um método (ex.: cartão de crédito e débito): o cliente diz qual antes da maquininha. */
export default function EscolhaMetodo({ forma, valorFormatado, onEscolher }: EscolhaMetodoProps): JSX.Element {
    const metodos = metodosDoCheckout(forma)

    return (
        <Stack spacing={4} sx={{ flex: '1 0 auto', alignItems: 'center', justifyContent: 'center', p: 3 }}>
            <Stack spacing={1} sx={{ alignItems: 'center', textAlign: 'center' }}>
                <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                    Como você vai pagar?
                </Typography>

                <Typography variant="h5" color="text.secondary" sx={{ fontWeight: 400 }}>
                    {forma.descricao} · {valorFormatado}
                </Typography>
            </Stack>

            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 3, width: '100%', maxWidth: 650 }}>
                {metodos.map((metodo, index) => (
                    <PaymentMethodCard
                        key={metodo.id}
                        metodo={metodo}
                        onSelecionar={onEscolher}
                        spanCompleto={index === metodos.length - 1 && metodos.length % 2 !== 0}
                    />
                ))}
            </Box>
        </Stack>
    )
}
